const initFeaturedMedia = () => {

  if (document.querySelector('[data-featured-media-swiper] video') === null) return;

  function handleSlideVideos() {
    const slides = document.querySelectorAll('.swiper-slide');
    slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (!video) return;
      if (slide.classList.contains('swiper-slide-active')) {
        if (video.paused) video.play();
      } else {
        if (!video.paused) video.pause();
      }
    });
  }

  const swiperEl = document.querySelector('[data-featured-media-swiper]');
  if (swiperEl && swiperEl.swiper) {
    swiperEl.swiper.on('slideChangeTransitionEnd', handleSlideVideos);
  } else {
    const observer = new MutationObserver(handleSlideVideos);
    document.querySelectorAll('.swiper-slide').forEach(slide => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

};

export default initFeaturedMedia;